<section [formGroup]="formGroup" class="cvv-only">
    <div class="cvv-only-row">
        <p class="cvv-prompt-message">
            Enter the CVV from your saved card to confirm this payment.
        </p>

        <mat-form-field appearance="standard" class="vgs-iframe-field cvv-field" floatLabel="never">
            <app-payment-integration-form-field
                formControlName="cvv"
                [id]="'vgsCvvOnly'"
                [loaded]="!loading"
                field-min-size="15"
                [attr.aria-label]="cvvLabel + ' (required)'">
            </app-payment-integration-form-field>
        </mat-form-field>
    </div>

    <p *ngIf="getFieldError('cvv') as err" class="cvv-only-error" role="alert">{{ err }}</p>
</section>
